var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"value":_vm.row[_vm.prop],"active-value":_vm.activeValue,"inactive-value":_vm.inactiveValue},on:{"change":(e)=> { _vm.switchChange(e) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }